import { FormConfig } from "../../../../shared/types/legacy";

export const otpFormConfig: FormConfig = {
    name: {
        type: 'text',
        label: '',
        _label: 'finish_label_name',
        validators: ['required'],
        autocomplete: 'off',
        disabled: true,
        hidden: false,
    },
    nif: {
        type: 'text',
        label: '',
        _label: 'finish_label_nif',
        validators: ['required'],
        autocomplete: 'off',
        disabled: true,
        hidden: false,
    },
    otp: {
        type: 'text',
        label: '',
        _label: '',
        validators: ['required'],
        autocomplete: 'one-time-code',
        nombreService: 'otp',
        value: ''
    }
};
